import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"
import useSWR from "swr"
import type { ForFinancePaymentDetail, ForFinancePaymentListQuery } from "../types"

export interface GetForFinancePaymentsApiResponse {
  payments: ForFinancePaymentDetail[]
  totalCount: number
  page: number
  perPage: number
}

const buildUrl = (query: ForFinancePaymentListQuery) => {
  const params = new URLSearchParams()
  if (query.search) params.set("search", query.search)
  if (query.dateFrom) params.set("dateFrom", query.dateFrom)
  if (query.dateTo) params.set("dateTo", query.dateTo)
  params.set("order", query.order)
  params.set("direction", query.direction)
  params.set("page", String(query.page))
  return `${SMOOTH_LINE_API_URL}/base_api/smoother/screen/for_finance_payments?${params.toString()}`
}

export const useGetForFinancePayments = (query: ForFinancePaymentListQuery) => {
  const { getWithToken } = useSmoothApi()
  const url = buildUrl(query)

  const fetcher = async (fetchUrl: string): Promise<GetForFinancePaymentsApiResponse> => {
    const response = await getWithToken(fetchUrl)
    return response.data as GetForFinancePaymentsApiResponse
  }

  const swr = useSWR(url, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    // 422（送金予定日の範囲が不正）は再試行しても変わらないため再試行しない
    shouldRetryOnError: false,
    keepPreviousData: true,
  })

  return {
    payments: swr.data?.payments ?? [],
    totalCount: swr.data?.totalCount ?? 0,
    perPage: swr.data?.perPage ?? 200,
    isLoading: swr.isLoading,
    error: (swr.error as Error | undefined) ?? null,
    refresh: () => swr.mutate(),
  }
}
